module.exports = __webpack_public_path__ + "static/img/psd.e162d16b.png";